import { render, staticRenderFns } from "./keywords.view.vue?vue&type=template&id=58f8da78&scoped=true"
import script from "./keywords.view.vue?vue&type=script&lang=ts"
export * from "./keywords.view.vue?vue&type=script&lang=ts"
import style0 from "./keywords.view.vue?vue&type=style&index=0&id=58f8da78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8da78",
  null
  
)

export default component.exports